import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { FIRST_QUESTION_ROUTE } from 'Apps/Consultation/constants';

import Button from 'Components/LegacyButton';

import { getHaveCompletedHairProfile, getHaveOrders } from 'dux/user/selectors';
import { getIsAuthenticated, getIsAuthenticating } from 'dux/auth/selectors';
import * as ctaContent from 'assets/content/consultation/cta';

const getRenderParams = ({
  haveCompletedHairProfile,
  haveOrders,
  isAuthenticated,
  productName,
}) => {
  /* XXX: Might worth implementing a light state machine  */
  if (haveOrders) {
    return {
      to: '/account/reorder',
      label: ctaContent.reorder,
      dataClick: 'order-prose',
    };
  }

  if (isAuthenticated && haveCompletedHairProfile) {
    return {
      to: '/checkout',
      label: ctaContent.abandonedCart(productName),
      dataClick: 'order-prose',
    };
  }

  if (isAuthenticated) {
    return {
      to: FIRST_QUESTION_ROUTE,
      label: ctaContent.abandonedConsultation,
      dataClick: 'consultation',
    };
  }

  return {
    to: '/consultation',
    label: ctaContent.newUser(productName),
    dataClick: 'consultation',
  };
};

const ConsultationCTA = ({
  dataFrom,
  dataTestId,
  haveCompletedHairProfile,
  haveOrders,
  isAuthenticated,
  isAuthenticating,
  productName,
  render,
  label,
  theme,
  variant,
  ...props
}) => {
  const params = getRenderParams({
    haveCompletedHairProfile,
    haveOrders,
    isAuthenticated,
    productName,
  });

  if (isAuthenticating) {
    return null;
  }

  if (render) {
    return render(params);
  }

  return (
    <Button
      Component={Link}
      data-click={params.dataClick}
      data-from={dataFrom}
      data-testid={dataTestId}
      disabled={Boolean(params.disabled)}
      to={params.to}
      variant={variant ?? theme}
      {...props}
    >
      {label || params.label}
    </Button>
  );
};

ConsultationCTA.propTypes = {
  dataFrom: PropTypes.string,
  dataTestId: PropTypes.string,
  haveCompletedHairProfile: PropTypes.bool.isRequired,
  haveOrders: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isAuthenticating: PropTypes.bool.isRequired,
  productName: PropTypes.string,
  render: PropTypes.func,
  label: PropTypes.string,
  /**
   * @deprecated
   * please use variant instead.
   */
  theme: PropTypes.string,
  variant: PropTypes.string,
};

ConsultationCTA.defaultProps = {
  dataFrom: 'consultation-cta',
  dataTestId: null,
  render: null,
  /**
   * @deprecated
   * please use variant instead.
   */
  theme: 'sorbet',
  variant: null,
  productName: null,
  label: null,
};

const mapStateToProps = state => ({
  haveCompletedHairProfile: getHaveCompletedHairProfile(state),
  haveOrders: getHaveOrders(state),
  isAuthenticated: getIsAuthenticated(state),
  isAuthenticating: getIsAuthenticating(state),
});

export default connect(mapStateToProps, {})(ConsultationCTA);
